<template>
  <div class="container pb-4 mb-4">
        
    <div class="row pb-2">
        <div class="col"><h5>Contacts</h5></div>
        <div class="col text-right pt-1">
            <i class="fas fa-plus-circle mr-2"></i><a href="#/" @click="showModalNewContact()">New contact</a>
        </div>
        <!-- <div class="col text-right">
          <i v-if="uploading_file" class="fas fa-spinner fa-spin fa-1x"></i>
          <upload-article v-else @new-articles="updateArticleList"></upload-article>
        </div> -->
      </div>

      <div class="row">
      <div class="col">
        <google></google>
      </div>
    </div>

      <div class="row">
      <div class="col">
        <buttons @change-category="changeCategory"></buttons>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <search-box @update-search="updateSearch"></search-box>
        </div>
    </div>
     
    <b-card no-body class="card">
      <b-tabs v-model="tabIndex" card align="center">
        <b-tab title="Waiting" title-link-class="darklink">
          <b-card-text>
            <contacts-list :search_term="mySearchTerm" :category="myCategory" status="Waiting" page="Waiting"></contacts-list>
            </b-card-text>
        </b-tab>
        
        <b-tab title="Contacted" title-link-class="darklink">
          <b-card-text>
            <contacts-list :search_term="mySearchTerm" :category="myCategory" status="Contacted" page="Contacted"></contacts-list>
            </b-card-text>
        </b-tab>

        <b-tab title="Clicked" title-link-class="darklink">
          <b-card-text>
            <contacts-list :search_term="mySearchTerm" :category="myCategory" status="Clicked" page="Clicked"></contacts-list>
            </b-card-text>
        </b-tab>

        <b-tab title="Replied" title-link-class="darklink">
          <b-card-text>
            <contacts-list :search_term="mySearchTerm" :category="myCategory" status="Replied" page="Replied"></contacts-list>
            </b-card-text>
        </b-tab>

        <b-tab title="Registered" title-link-class="darklink">
          <b-card-text>
            <contacts-list :search_term="mySearchTerm" :category="myCategory" status="Registered" page="Registered"></contacts-list>
            </b-card-text>
        </b-tab>

        <b-tab title="Unsubscribed" title-link-class="darklink">
          <b-card-text>
            <contacts-list :search_term="mySearchTerm" :category="myCategory" status="Unsubscribed" page="Unsubscribed"></contacts-list>
            </b-card-text>
        </b-tab>

        <b-tab title="Failed" title-link-class="darklink">
          <b-card-text>
            <contacts-list :search_term="mySearchTerm" :category="myCategory" status="Failed" page="Failed"></contacts-list>
            </b-card-text>
        </b-tab>
        
      </b-tabs>
    </b-card>

  <new-contact ref="NewContact"></new-contact>
</div>

</template> 

<script>
export default {
  data() {
    return {
        tabIndex: 0,
        mySearchTerm: '',
        myCategory: 'Autoshare',
        uploading_file: false,
    };
  },

  methods: {

    updateArticleList() {
      this.$emit('new-articles');
    },

    showModalNewContact() {
      this.$refs.NewContact.clearInfo();
      this.$bvModal.show('bv-modal-new-contact');
    },

    updateSearch(newSearchTerm) {
      this.mySearchTerm = newSearchTerm;
    },

    changeCategory(newCategory) {
      this.myCategory = newCategory;
      console.log('Category changed to ' + this.myCategory);
    }

  }

}
</script>